document.addEventListener("DOMContentLoaded", function () {
  // Select all buttons with the class
  var buttons = document.querySelectorAll(".custom-button__slap");

  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var target = document.querySelector(".cb_product_sizes");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
});
